"use client";

import { Bed, Download, Map } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "Köp din digitala guide",
  description: "Ladda ner din kompletta reseguide med interaktiva GPX-kartor direkt till din telefon efter genomfört köp.",
  icon: Download
}, {
  title: "Boka ditt boende",
  description: "Använd våra handplockade rekommendationer och logistiktips för att boka hotell och transport i din egen takt.",
  icon: Bed
}, {
  title: "Njut av äventyret",
  description: "Ge dig ut på leden med full trygghet. Du har expertisen från en resebyrå, men friheten att styra din egen resa.",
  icon: Map
}];
export default function HowItWorks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="så-fungerar-det" className="dark bg-background text-foreground py-20 px-4 md:px-8 overflow-hidden">
      <div ref={ref} className={`max-w-6xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex flex-col items-center text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-6">
            Så fungerar det
          </h2>
          <Separator className="w-16 h-1 bg-primary rounded-full" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, i) => <div data-index={i} key={i} className="h-full">
              <Card className="h-full bg-card border-border border-b-2 border-b-transparent hover:border-b-accent transition-all duration-300 shadow-sm hover:shadow-md">
                <CardHeader className="flex flex-col items-center text-center pb-4">
                  <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-6 text-primary">
                    <step.icon className="w-8 h-8" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-xl font-semibold">
                    <span className="text-accent mr-2">{i + 1}.</span>
                    {step.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center pt-0">
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {step.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}